export const YEAR = new Date().getFullYear();

export const TW_BASE_URL = "https://myteamwork.openxcell.dev/";

export const ROUTE_PERMISSION = {
	SUB_ADMIN_MANAGEMENT: "sub-admin-management",
	CAMPAIGN_MANAGER: "campaign-manager",
	MASTER_REP_MANAGEMENT: "master-rep-management",
	SALES_OFFICE_MANAGEMENT: "sales-office-management",
	MEMBER: "participant",
};

export const USER_ROLE_TYPE = {
	ADMIN: "ADMIN",
	SUB_ADMIN: "SUB ADMIN",
	CAMPAIGN_MANAGER: "CAMPAIGN MANAGER",
	MASTER_REP: "MASTER REP",
	SALES_REP: "SALES REP",
	MEMBER: "MEMBER",
	STUDENT: "STUDENT",
	PARENT: "PARENT",
};

export const BACKEND_ROLES = {
	ADMIN: "Admin",
	SUB_ADMIN: "SubAdmin",
	CAMPAIGN_MANAGER: "CampaignManager",
	MASTER_REP: "MasterRep",
	SALES_REP: "SalesRep",
	MEMBER: "Member",
};

export const MEMBER_TYPE = {
	STUDENT: "student",
	PARENT: "parent",
	CAMPAIGN_MANAGER: "campaignManager",
};

export const SUPPORTED_FORMATS = ["image/jpg", "image/jpeg", "image/png"];

export const FILTER_TYPES = {
	CURRENT: "current",
	ACTIVE: "active",
	INACTIVE: "inactive",
	PAST: "past",
	DEFAULT: "",
};

export const MODAL_TYPES = {
	ADD: "ADD",
	EDIT: "EDIT",
	DELETE: "DELETE",
	CANCEL: "CANCEL",
};

export const CURRENT_PAST_FUNDRAISER_TYPE = {
	SALES_REP: "salesRep",
	MASTER_REP: "masterRep",
};
